import {
  PRICELIST_UPLOAD_ACCEPT,
  validatePricelistFile,
  type TranslateFn,
  type UploadFileRejection,
  type ValidatePricelistFileOptions,
} from 'src/lib/pricelist-utils';
import { acceptDroppedFiles } from './fileDropzoneAccept';

export async function resolvePricelistDrop(
  files: readonly File[],
  gt: TranslateFn,
  options?: ValidatePricelistFileOptions,
): Promise<{
  files: File[];
  file: File | null;
  rejections: UploadFileRejection[];
}> {
  const { accepted, rejections } = await acceptDroppedFiles(
    files,
    PRICELIST_UPLOAD_ACCEPT,
    (file) => validatePricelistFile(file, gt, options),
    gt,
  );
  return { files: accepted, file: accepted[0] ?? null, rejections };
}
